document.documentElement.classList.remove('no-js');

const body = document.body;
const overlay = document.querySelector('[data-overlay]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
const searchPanel = document.querySelector('[data-search-panel]');

function openPanel(panel) {
  if (!panel) return;
  panel.setAttribute('aria-hidden', 'false');
  panel.classList.add('is-open');
  overlay?.classList.add('is-open');
  body.classList.add('no-scroll');
}
function closePanels() {
  [mobileMenu, searchPanel].forEach((panel) => {
    panel?.setAttribute('aria-hidden', 'true');
    panel?.classList.remove('is-open');
  });
  overlay?.classList.remove('is-open');
  body.classList.remove('no-scroll');
}
document.querySelector('[data-menu-open]')?.addEventListener('click', () => openPanel(mobileMenu));
document.querySelector('[data-menu-close]')?.addEventListener('click', closePanels);
document.querySelector('[data-search-open]')?.addEventListener('click', () => {
  openPanel(searchPanel);
  setTimeout(() => searchPanel?.querySelector('input')?.focus(), 200);
});
document.querySelector('[data-search-close]')?.addEventListener('click', closePanels);
overlay?.addEventListener('click', closePanels);
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closePanels(); });

const cartToast = document.querySelector('[data-cart-toast]');
let cartToastTimer;

function showCartToast(message) {
  if (!cartToast) return;
  const messageNode = cartToast.querySelector('[data-cart-toast-message]');
  if (messageNode) messageNode.textContent = message;
  cartToast.classList.add('is-visible');
  window.clearTimeout(cartToastTimer);
  cartToastTimer = window.setTimeout(() => cartToast.classList.remove('is-visible'), 4200);
}

document.querySelectorAll('.quick-add-form').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Cart request failed');
      const rootUrl = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      document.querySelectorAll('.cart-count').forEach((count) => { count.textContent = cart.item_count; });
      showCartToast(window.themeStrings?.addedToCart || 'Added to cart');
    } catch {
      showCartToast(window.themeStrings?.addError || 'Please try again');
    } finally {
      if (button) button.disabled = false;
    }
  });
});

const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.12 }) : null;
document.querySelectorAll('[data-reveal]').forEach((element) => revealObserver ? revealObserver.observe(element) : element.classList.add('is-visible'));

document.querySelector('[data-sort-select]')?.addEventListener('change', (event) => {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', event.target.value);
  window.location.href = url.toString();
});

const catalogGrid = document.querySelector('[data-catalog-grid]');
const catalogView = new URL(window.location.href).searchParams.get('view');
if (catalogGrid && catalogView === 'candles') {
  const productCards = [...catalogGrid.querySelectorAll('[data-catalog-product-kind]')];
  const candleCards = productCards.filter((card) => card.dataset.catalogProductKind === 'candle');

  productCards.forEach((card) => {
    card.hidden = card.dataset.catalogProductKind !== 'candle';
  });

  const count = document.querySelector('[data-catalog-count]');
  if (count) {
    count.textContent = (count.dataset.countTemplate || '__COUNT__').replace('__COUNT__', String(candleCards.length));
  }

  document.querySelectorAll('[data-catalog-filter]').forEach((link) => {
    if (link.dataset.catalogFilter === 'candles') {
      link.setAttribute('aria-current', 'page');
    } else {
      link.removeAttribute('aria-current');
    }
  });

  const hero = document.querySelector('[data-catalog-hero]');
  if (hero) {
    const eyebrow = hero.querySelector('[data-catalog-eyebrow]');
    const heading = hero.querySelector('[data-catalog-heading]');
    const summary = hero.querySelector('[data-catalog-summary]');
    if (eyebrow && hero.dataset.candleEyebrow) eyebrow.textContent = hero.dataset.candleEyebrow;
    if (heading && hero.dataset.candleHeading) heading.textContent = hero.dataset.candleHeading;
    if (summary && hero.dataset.candleIntro) summary.textContent = hero.dataset.candleIntro;
  }
}

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const variantsNode = root.querySelector('[data-product-json]');
  if (!variantsNode) return;
  const variants = JSON.parse(variantsNode.textContent || '[]');
  const idInput = root.querySelector('[data-variant-id]');
  const addButton = root.querySelector('[data-add-to-cart]');
  const mobileAddButton = root.querySelector('[data-mobile-add]');
  const currentPrice = root.querySelector('[data-price-current]');
  const mobilePrice = root.querySelector('[data-mobile-price]');
  const optionInputs = root.querySelectorAll('input[name^="options["]');

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: window.themeCurrency || 'EUR'
      }).format(Number(cents || 0) / 100);
    } catch {
      return `${(Number(cents || 0) / 100).toFixed(2)} €`;
    }
  }

  function updateVariant() {
    const selected = [...root.querySelectorAll('fieldset[data-option-position]')].map((fieldset) => fieldset.querySelector('input:checked')?.value);
    const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
    if (!variant || !idInput) return;
    idInput.value = variant.id;
    if (currentPrice) currentPrice.textContent = formatMoney(variant.price);
    if (mobilePrice) mobilePrice.textContent = formatMoney(variant.price);
    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.querySelector('span').textContent = variant.available ? (window.themeStrings?.addToCart || 'Add to cart') : (window.themeStrings?.soldOut || 'Sold out');
    }
    if (mobileAddButton) {
      mobileAddButton.disabled = !variant.available;
      mobileAddButton.textContent = variant.available ? (window.themeStrings?.addToCart || 'Add to cart') : (window.themeStrings?.soldOut || 'Sold out');
    }
    if (variant.featured_media?.id) {
      root.querySelectorAll('[data-media-id]').forEach((media) => {
        media.classList.toggle('is-selected', String(media.dataset.mediaId) === String(variant.featured_media.id));
      });
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }
  optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  const quantity = root.querySelector('input[name="quantity"]');
  root.querySelector('[data-qty-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
  root.querySelector('[data-qty-plus]')?.addEventListener('click', () => { quantity.value = Number(quantity.value || 1) + 1; });

  const mobilePurchase = root.querySelector('[data-mobile-purchase]');
  if (mobilePurchase && addButton && 'IntersectionObserver' in window) {
    const purchaseObserver = new IntersectionObserver(([entry]) => {
      mobilePurchase.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0.15 });
    purchaseObserver.observe(addButton);
  }
});

document.querySelectorAll('[data-product-root] form.product-form').forEach((form) => {
  const root = form.closest('[data-product-root]');
  const options = root?.querySelector('[data-bouquet-addons]');
  if (!root || !options) return;

  const cardCheckbox = options.querySelector('[data-greeting-card-checkbox]');
  const cardFields = options.querySelector('[data-greeting-card-fields]');
  const cardText = cardFields?.querySelector('textarea');
  const totalNode = options.querySelector('[data-addon-total]');
  const addButtons = root.querySelectorAll('[data-add-to-cart], [data-mobile-add]');

  function formatAddonMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: window.themeCurrency || 'EUR'
      }).format(Number(cents || 0) / 100);
    } catch {
      return `${(Number(cents || 0) / 100).toFixed(2)} €`;
    }
  }

  function updateAddonDisplay() {
    const selected = [...options.querySelectorAll('[data-addon-variant]:checked')];
    const total = selected.reduce((sum, input) => sum + Number(input.dataset.addonPriceCents || 0), 0);
    if (totalNode) {
      totalNode.hidden = total === 0;
      totalNode.textContent = total ? `${totalNode.dataset.label}: +${formatAddonMoney(total)}` : '';
    }
    if (cardCheckbox && cardFields && cardText) {
      cardFields.hidden = !cardCheckbox.checked;
      cardText.disabled = !cardCheckbox.checked;
      cardText.required = cardCheckbox.checked;
    }
  }

  options.addEventListener('change', updateAddonDisplay);
  updateAddonDisplay();

  form.addEventListener('submit', async (event) => {
    const selected = [...options.querySelectorAll('[data-addon-variant]:checked')];
    if (!selected.length) return;

    event.preventDefault();
    addButtons.forEach((button) => { button.disabled = true; });
    try {
      const formData = new FormData(form);
      const quantity = Math.max(1, Number(formData.get('quantity') || 1));
      const bouquetTitle = root.querySelector('h1')?.textContent.trim() || '';
      const bouquet = {
        id: Number(formData.get('id')),
        quantity,
        properties: {}
      };
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim()) bouquet.properties[match[1]] = String(value).trim();
      }
      const items = [bouquet, ...selected.map((input) => ({
        id: Number(input.dataset.addonVariant),
        quantity,
        properties: { 'Zu Bouquet': bouquetTitle }
      }))];
      const rootUrl = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Cart request failed');
      const cartResponse = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      document.querySelectorAll('.cart-count').forEach((count) => { count.textContent = cart.item_count; });
      showCartToast(window.themeStrings?.addedToCart || 'Added to cart');
    } catch {
      showCartToast(window.themeStrings?.addError || 'Please try again');
    } finally {
      addButtons.forEach((button) => { button.disabled = false; });
    }
  });
});

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url || this.innerHTML.trim()) return;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations?.innerHTML.trim()) this.innerHTML = recommendations.innerHTML;
      })
      .catch(() => {});
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
